import Vue from 'vue';
import VueRouter from 'vue-router';
import Form from './component/forms/forms.vue';
import TaskForm from './component/taskform/taskForm.vue';
import Public from './component/public/public.vue';
import Private from './component/private/private.vue';
import Slider from './component/slidermanagement/Main.vue';
//import CartableAdmin from './component/CartableAdmin/CartableAdmin.vue';
import Legacy from './component/legacyform/Legacy.js';
import CartableGrid from './component/cartableGrid/cartableGrid.vue';
import VacationCalendar from './component/calendarmanagement/CalendarManagement.vue';
import UI from './component/appearancemanagement/Main.vue';
//import HomeUI from './component/HomeManagement/HomeManagement.vue';
//import AddNews from './component/NewsManagement/NewsManagement.vue';
import SendMessage from './component/message/SendMessage.vue';
import MessageGrid from './component/messageGrid/MessageGrid.vue';
import ViewMessage from './component/message/ViewMessage.vue';
import TimeSheet from './component/timesheet/timesheet.vue';
import Dms from './component/dms/Dms.vue';
import DmsManage from './component/dms/DmsManage.vue';
import BPMSLogs from "./component/bpmslogs/BPMSLogs.vue";
import ChangePassword from "./component/changepassword/ChangePassword.vue";
import RuleManagement from "./component/rulemanagement/RuleManagement.vue";
import NewDelegations from "./component/delegation/DelegationManagement.vue";
import TimeSheetManagement from "./component/timesheet/TimeSheetManagement.vue";
import HomeManagement from "./component/homemanagement/Main.vue";
import CartableAdmin from './component/cartableadmin/Main.vue';
import TrackingManagement from './component/tracking/TrackingManagement.vue';
import MainNews from './component/newsmanagement/Main.vue';
import SessionManager from './component/SessionManager/SessionManager.vue';

Vue.use(VueRouter);

const routes = [
    { path: '/:parentId([a-zA-Z0-9_-]{36})', component: Public, name: 'home' },
    { path: '/', component: Public, name: 'home-menu' },
    { path: '/form/:id/:isTopMenu?', component: Form, name: "form" },
    { path: '/taskForm/:id/:folderId/:taskTypeId/:status/:isDraft/:folderName?', component: TaskForm, name: "taskForm" },
    { path: '/tracking', component: TrackingManagement, name: "tracking" },
    { path: '/dms', component: Dms, name: "dms" },
    { path: '/dmsManage', component: DmsManage, name: "dmsManage" },
    { path: '/tasks/:folderId/:parentId?/:folderName?', component: CartableGrid, name: 'tasksGrid' },
    { path: '/slider-managemet', component: Slider, name: "slider" },
    { path: '/cartable-admin', component: CartableAdmin, name: "cartable-admin" },
    { path: '/calendar-management', component: VacationCalendar, name: "calnedar-management" },
    { path: '/appearance-management', component: UI, name: "appearance-management" },
    //{ path: '/home-management', component: HomeUI, name: "home-management" },
    { path: '/news-management', component: MainNews, name: "news-management" },
    { path: '/send-message', component: SendMessage, name: "send-message" },
    { path: '/message-grid/:isReceivedMessage?', component: MessageGrid, name: "message-grid" },
    { path: '/view-message/:messageId?/:isReceiveMessage?', component: ViewMessage, name: "view-message" },
    { path: '/timesheet', component: TimeSheet, name: "timesheet" },
    { path: '/timesheet/:id/:cmp', component: TimeSheet, name: 'timesheet-legacy' },
    { path: '/logs', component: BPMSLogs, name: 'BPMSLogs' },
    { path: '/changePassword', component: ChangePassword, name: 'ChangePassword' },
    { path: '/DelegationsUserControl', component: NewDelegations, name: "delegate-user" },
    { path: '/TaskForm', component: TaskForm, name: "taskFormtop" }, // eoffice notification
    { path: '/rule-management/:pId', component: RuleManagement, name: "rule-management" },
    { path: '/delegation-management', component: NewDelegations, name: "delegation-management" },
    { path: '/timesheet-management', component: TimeSheetManagement, name: "timesheet-management" },
    { path: '/home-management', component: HomeManagement, name: "home-management" },
    { path: '/SessionManager', component: SessionManager, name:"SessionManager"}
];

const routePermissionMapp = {
    "taskForm": ["not-annonymous", "ShowTasks"],
    "tracking": ["ViewProcessTracking"],
    "dms": ["CMSUser"],
    "dmsManage": ["CMSAdmin"],
    "tasksGrid": ["ShowTasks"],
    "slider": ["Slider"],
    "cartable-admin": ["AdminRole", "CartableAdmin"],
    "calnedar-management": ["not-annonymous"],
    "appearance-management": ["AdminRole", "UICustomization"],
    "home-management": ["AdminRole", "HomeUICustomization"],
    "news-management": ["AdminRole", "NewsManagement"],
    "send-message": ["SendBpmsMessage"],
    "message-grid": ["not-annonymous"],
    "view-message": ["not-annonymous"],
    "timesheet": ["TimeSheet"],
    "delegation-management": ["Delegation"],
    "delegationCreate": ["Delegation"],
    "delegationEdit": ["Delegation"],
    "timesheet-legacy": ["TimeSheet"],
    "BPMSLogs": ["ViewErrors"],
    "ChangePassword": ["not-annonymous"],
    "delegate-user": ["Delegation"],
    "rule-management": ["not-annonymous"],
    "SessionManagert": ["not-annonymous", "AdminRole","SessionManagement"],
    "timesheet-management": ["TimeSheet"], 
   
};


const userPermissions = JSON.parse(JSON.stringify(payload.permissions));
const routerInstance = new VueRouter({ routes: routes });

routerInstance.beforeEach((to, from, next) => {
    var isAllowed = true;
    routerInstance.from = from;
    // BPMS - EOffice Plugin, by sending a message from iframe to parent, EOA will provide a scrollbar for BPMS
    if (window.self !== window.top) {
        setTimeout(() => parent.postMessage('test', payload.eoaUrl), 500);
    }
    if ((to.path === '/' && to.name === 'home-menu') && typeof payload.CurrentUser !== 'undefined'
        && payload.newsItems.length === 0 && !payload.hasRootMenuItem
        && payload.announcementItems.length == 0) {

        next(false)

        // find staff
        if (global.redirectToSelectedNode != null)
            global.redirectToSelectedNode();
        else {
            let staffs = payload.treeItems[0].ChildItems.filter(t => t.ItemType === 2)
            if (staffs.length === 0 || payload.ExpandStaffTree === false) {
                router.push({
                    name: 'tasksGrid',
                    params: {
                        folderId: payload.treeItems[0].ChildItems[0].Id,
                        //folderName: payload.treeItems[0].Text + " - " + payload.treeItems[0].ChildItems[0].Text
                    }
                });
            } else {
                router.push({
                    name: 'tasksGrid',
                    params: {
                        folderId: staffs[0].ChildItems[0].Id,
                       // folderName: staffs[0].Text + " - " + staffs[0].ChildItems[0].Text
                    }
                });
            }
        }
        //return
    }

    if (typeof routePermissionMapp[to.name] === "undefined") {
        next();
        return;
    }

    for (var item of routePermissionMapp[to.name]) {
        if (item == "not-annonymous")
            isAllowed = isAllowed && typeof payload.CurrentUser !== "undefined";
        else
            isAllowed = isAllowed && userPermissions[item]
    }

    if (isAllowed)
        next();
    else {
        next(false)
        routerInstance.push({ name: 'home' });
    }

});


if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
    window.addEventListener("hashchange", function (event) {
        var currentPath = window.location.hash.slice(1);
        if (routerInstance.app.$route.path !== currentPath) {
            routerInstance.push(currentPath)
        }
    }, false)
}

global.router = routerInstance;
export const router = routerInstance;
